import BaseRequest from './base/BaseRequest';

export default class CoinMarketCap extends BaseRequest {

  getCurrentRates() {
    const url = '/coin-makert-cap/current-rate';
    return this.get(url);
  }
}
